import type { OpticlockEntry, OpticlockProjectSplit } from '@staff-app/shared-types';

/**
 * Group an agent's own entries into a per-project split, client-side.
 *
 * Deliberately NOT a new query: `opticlockMyEntries` already returns every entry for the month
 * with its project name and colour, so the agent's own breakdown is a fold over data already on
 * the page. A second round trip could also disagree with the list right above it.
 *
 * Sorted minutes-DESC to match the ordering the SERVER applies to the dashboard's `byProject`.
 * That parity is what keeps a project the same colour and position in both views.
 */
export function splitByProject(entries: OpticlockEntry[]): OpticlockProjectSplit[] {
  const acc = new Map<string, OpticlockProjectSplit>();
  for (const e of entries) {
    const cur = acc.get(e.projectId);
    if (cur) {
      cur.minutes += e.minutes;
    } else {
      acc.set(e.projectId, {
        projectId: e.projectId,
        name: e.projectName ?? e.projectId,
        color: e.projectColor ?? null,
        minutes: e.minutes,
      });
    }
  }
  return [...acc.values()].sort((a, b) => b.minutes - a.minutes || a.name.localeCompare(b.name));
}
